module.exports = __webpack_public_path__ + "media/earth-takes-over.e793cb1a.mp3";